import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Tooltip, TextField
} from "@mui/material";
import PricingCopyMenu from './PricingCopyMenu'

const MinInput = ({ day, room, season, seasonEditCopyRef, isReadOnlyMode, manageSeasonChangeFunc, discardCount, globalErrorMsg, disableDownCopy, disableRightCopy, copyInputCount, registerRef, onNavigate }) => {
    let min = null;
    let max = null;
    if (seasonEditCopyRef.current.dependent_room_type.room_type[room]) {
        min = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        max = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;
    }

    const inputRef = useRef(null);
    const [inputErrorMsg, setInputErrorMsg] = useState(false);

    const [isBaseRoomTypeChanged, setIsBaseRoomTypeChanged] = useState(season.isBaseRoomTypeChanged);

    const handleInputBlur = (event) => {
        min = event.target.value.trim();
        // let max = max;

        // remove decimal if any
        if (min.includes('.')) {
            min = min.split('.')[0];
            event.target.value = min;
        }


        // if min has negative sign then remove it
        if (min.includes('-')) {
            min = 1;
            min = Number(min);
            event.target.value = min;
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if min is blank
        if (min === '') {
            setInputErrorMsg('This field is required.');
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min = null;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }
        setIsBaseRoomTypeChanged(false);

        // if max is blank then min can be any positive number
        if (!max && max !== 0) {
            min = Number(min);
            setInputErrorMsg(false);
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if min is greater than max
        min = Number(min);
        max = Number(max);
        if (min > max) {
            setInputErrorMsg('Floor cannot be greater than ceiling.');
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        setInputErrorMsg(false);
        seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min = min;
        manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });

    }

    const handleCopyRight = () => {
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        const dayKeys = Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type[room]);
        const currentIndex = dayKeys.indexOf(day);
        if (currentIndex === -1) return;

        // Copy value to the right-side inputs
        for (let i = currentIndex + 1; i < dayKeys.length; i++) {
            const nextDay = dayKeys[i];
            seasonEditCopyRef.current.dependent_room_type.room_type[room][nextDay].min = currentValue;

        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current
        });
        setIsBaseRoomTypeChanged(false);
        //console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    const handleCopyDown = () => {
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        const allRooms = Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type); //deepCopy(inventoryRoomCodes);
        const currentRoomIndex = allRooms.indexOf(room);
        if (currentRoomIndex === -1) return;

        // Copy value to the below inputs of same day 
        for (let i = currentRoomIndex + 1; i < allRooms.length; i++) {
            const nextRoom = allRooms[i];
            seasonEditCopyRef.current.dependent_room_type.room_type[nextRoom][day].min = currentValue;
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current,
        });
    };


    // Register on every render (IMPORTANT)
    registerRef("min", day, room, inputRef);

    useEffect(() => {
        setInputErrorMsg(false);
        inputRef.current.value = season.dependent_room_type.room_type[room]?.[day]?.min || null;
    }, [discardCount])


    useEffect(() => {
        if (seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max && seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min && seasonEditCopyRef.current.dependent_room_type.room_type[room][day]) {
            let min = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
            let max = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;
            if (min > max) {
                setInputErrorMsg('Floor cannot be greater than ceiling.');
            }
            else {
                setInputErrorMsg(false);
            }
        }
    }, [globalErrorMsg.length]);


    useEffect(() => {
        inputRef.current.value = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;

        // If min is valid (not null), clear the "required" error
        const minValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].min;
        const maxValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day].max;

        if (minValue !== null && minValue !== '') {
            setInputErrorMsg(false);
            setIsBaseRoomTypeChanged(false);

        }

        // If both exist, revalidate relationship
        if (minValue !== null && maxValue !== null) {
            if (Number(minValue) > Number(maxValue)) {
                setInputErrorMsg("Floor cannot be greater than ceiling.");
            } else {
                setInputErrorMsg(false);
            }
        }


    }, [copyInputCount]);


    const handleArrowKeyNavigation = (e) => {
        const navKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (!navKeys.includes(e.key)) return;

        e.preventDefault();
        const direction = e.key.replace("Arrow", "").toLowerCase();
        onNavigate(direction, day, room, "min");
    };



    return (
        <Box className="grid-col" >
            <Tooltip
                arrow
                title={inputErrorMsg}
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 350,
                        },
                    },
                }}
            >
                <TextField
                    type="number"
                    inputRef={inputRef}
                    // className={`custom-textfield ${inputErrorMsg ? 'error' : ''}`}
                    className={`custom-textfield 
                        ${inputErrorMsg ? 'error' : ''}
                        ${min === null && !season.id.includes('new_') ? 'empty_field' : ''} 
                    `}
                    size="small"
                    fullWidth
                    margin="dense"
                    disabled={isReadOnlyMode}
                    defaultValue={min}
                    onFocus={(e) => setTimeout(() => e.target.select(), 0)}
                    onBlur={(event) => { handleInputBlur(event) }}
                    onKeyDown={handleArrowKeyNavigation}
                    autoComplete="off"
                />
                {!isReadOnlyMode && min !== null && min !== undefined && (
                    <PricingCopyMenu
                        disableDownCopy={disableDownCopy}
                        disableRightCopy={disableRightCopy}
                        onCopyRight={handleCopyRight}
                        onCopyDown={handleCopyDown}
                    />
                )}
            </Tooltip>
        </Box>
    )
}

export default MinInput